import React, { useCallback, useEffect, useRef } from 'react';
import UserPicker, {
	type UserOption,
	mapUserObjectToUserOption,
} from '@atlassian/jira-base-user-picker';

import { REPORTER_TYPE } from '@atlassian/jira-platform-field-config';
import { useCurrentUser } from '@atlassian/jira-platform-services-user-current';

import type { Props } from './types';
import { fetchSuggestions } from './utils';

const ReporterEdit = (props: Props) => {
	const {
		allowEmail = false,
		appearance,
		width,
		onChange,
		onSelection,
		value = null,
		autoFocus = false,
		placeholder = '',
		isDisabled = false,
		autoCompleteUrl,
		onCancel,
		isClearable = true,
		fetchSuggestions: fetchSuggestionsProps,
		shouldSetDefaultValue: shouldSetDefaultValueProp = true,
		openMenuOnClick = false,
		...fieldProps
	} = props;

	const {
		data: { user },
	} = useCurrentUser();

	const shouldSetDefaultValue = useRef(!value && shouldSetDefaultValueProp);

	// to store default value in form field wrapper if value is not set
	useEffect(() => {
		if (shouldSetDefaultValue.current && user && !value) {
			shouldSetDefaultValue.current = false;
			onChange(mapUserObjectToUserOption(user, true));
		}
	}, [onChange, user, value]);

	const fetchSuggestionsCallback = useCallback(
		async (query: string | null): Promise<UserOption[]> => fetchSuggestions(autoCompleteUrl, query),
		[autoCompleteUrl],
	);

	return (
		<UserPicker
			{...fieldProps}
			appearance={appearance}
			width={width}
			fieldId={REPORTER_TYPE}
			autoCompleteUrl={autoCompleteUrl}
			// @ts-expect-error TS2322: Type (arg1: UserOption) => void is not assignable to type (arg1: UserOption | UserOption[]) => void
			onChange={onChange}
			value={value}
			autoFocus={autoFocus}
			placeholder={placeholder}
			isDisabled={isDisabled}
			fetchSuggestions={fetchSuggestionsProps || fetchSuggestionsCallback}
			onSelection={onSelection}
			onCancel={onCancel}
			isClearable={isClearable}
			allowEmail={allowEmail}
			shouldShowEmailInOptions
			openMenuOnClick={openMenuOnClick}
		/>
	);
};

export default ReporterEdit;
